/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/ShippingBanner/index.tsx
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Thu Apr 17 2025
 */

import React, { useContext, useState } from "react";
import { TranslationsContext, FormContext } from '@proxy/_contexts';
import {
  Banner,
  CheckBox,
} from "@proxy/_components";

const ShippingBanner = (): React.JSX.Element => {

  const translations = useContext(TranslationsContext);
  const { settings, bulkOrder, fulfillmentType, currentStep, formErrors } = useContext(FormContext);

  const [shippingTermsAccepted, setShippingTermsAccepted] = useState(false);

  const shouldDisplayBanner = (
    fulfillmentType === "physical" &&
    !bulkOrder && (
      settings.physical?.appearance?.shipping_terms_banner === "visible" ||
      settings.physical?.appearance?.shipping_terms_banner === "visible_with_checkbox"
    ) && (
      settings?.global?.appearance?.form_theme === "simple" ||
      settings?.global?.appearance?.form_theme === "crisp" ||
      currentStep === "gift_message"
    )
  );

  const showCheckbox = (settings.physical?.appearance?.shipping_terms_banner === "visible_with_checkbox");

  return ((shouldDisplayBanner) ?
    <Banner
      status="notice"
      className="gc__physical-shipping-banner"
    >
      <strong>{translations.shipping_terms_title}</strong>
      <p>{translations.shipping_terms_text}</p>
      {(showCheckbox) ?
        <CheckBox
          checked={shippingTermsAccepted}
          label={translations.shipping_terms_checkbox_label}
          name="_gcp_shipping_terms_accepted"
          onChange={() => {
            setShippingTermsAccepted(!shippingTermsAccepted);
          }}
          value="1"
          error={(formErrors["_gcp_shipping_terms_accepted"])}
        />
      : null}
    </Banner>
  : <></>);
};

export default ShippingBanner;
